import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function ForWhoSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forWho = ['Mamás hispanas USA 40-55 con calorones nocturnos', 'Perimenopausia irregulares post-familia', 'Buscadoras remedios naturales sin hormonas', 'Ocupadas queriendo 6hrs sueño', 'Listas trackear en español cultural', 'Con tía que usaba ruda/manzanilla'];
  const notFor = ['Ya en terapia hormonal full', 'Ignorando doctor (usa junto citas)', 'Queriendo pastillas rápidas', 'Sin tiempo 2min diarios', 'Trackers digitales fancy (esto imprime fácil)'];
  return <section ref={ref} className="w-full gradient-purple-soft py-20 px-4 sm:px-6 lg:px-8" data-id="element-142">
      <div className="max-w-6xl mx-auto" data-id="element-143">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-144">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8
        }} className="bg-white rounded-3xl p-8 sm:p-10 shadow-xl" data-id="element-145">
            <h3 className="text-purple-deep text-3xl sm:text-4xl font-bold font-heading mb-8 text-center" data-id="element-146">
              ✅ Para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-147">
              {forWho.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.6,
              delay: 0.2 + index * 0.1
            }} className="flex items-start gap-3" data-id="element-148">
                  <CheckCircle2Icon className="w-6 h-6 text-sage flex-shrink-0 mt-1" data-id="element-149" />
                  <span className="text-gray-800 text-lg leading-relaxed" data-id="element-150">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8
        }} className="bg-white rounded-3xl p-8 sm:p-10 shadow-xl" data-id="element-151">
            <h3 className="text-purple-deep text-3xl sm:text-4xl font-bold font-heading mb-8 text-center" data-id="element-152">
              ❌ No para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-153">
              {notFor.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.6,
              delay: 0.2 + index * 0.1
            }} className="flex items-start gap-3" data-id="element-154">
                  <XCircleIcon className="w-6 h-6 text-coral flex-shrink-0 mt-1" data-id="element-155" />
                  <span className="text-gray-700 text-lg leading-relaxed" data-id="element-156">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}